import { Card, Skeleton } from '@resolute/ui';

/**
 * Placeholder for `PropertyCard`, deliberately mirroring that card's body
 * structure row-for-row: image, title, location, price.
 *
 * The match matters more than it looks — this was once 53px shorter than the
 * real card, so every grid of skeletons snapped taller the moment results
 * arrived, which was the second-largest layout shift on the home page. Keep the
 * two in step if either changes: the config/area footer was dropped from both
 * at the same time for exactly this reason.
 */
export function PropertyCardSkeleton() {
  return (
    <Card className="overflow-hidden">
      {/* Matches CardImageCarousel's aspect ratio, so the image never resizes. */}
      <Skeleton className="aspect-[4/3] w-full rounded-none" />
      <div className="flex flex-col gap-2 p-4">
        {/* title — text-lg */}
        <Skeleton className="h-7 w-3/4" />
        {/* locality, city — text-sm */}
        <Skeleton className="h-5 w-1/2" />
        {/* price + verified badge row — text-lg */}
        <Skeleton className="h-7 w-2/3" />
      </div>
    </Card>
  );
}
